import { render, staticRenderFns } from "./CreatedQuestions.vue?vue&type=template&id=2dc6029d&"
import script from "./CreatedQuestions.vue?vue&type=script&lang=js&"
export * from "./CreatedQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports